import { render, staticRenderFns } from "./UserRules.vue?vue&type=template&id=7b7aee04&"
import script from "./UserRules.vue?vue&type=script&lang=js&"
export * from "./UserRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports